<template>
  <div
    v-if="isPromoVisible"
    :id="content.idHTML"
    class="d-flex flex-column align-items-center"
    :class="jel_getClassObject(content)"
  >
    <b-link
      :class="[content.variantBoutonCodePromo ? content.variantBoutonCodePromo : 'hyperlienModal']"
      @click="$bvModal.show(modaleUUID)"
      >{{ content.libBoutonCodePromo }}</b-link
    >
    <b-modal
      :id="modaleUUID"
      hide-footer
      centered
      align-h="center"
      content-class="compteClair"
      body-class="mx-2 mx-md-4 pt-0 mb-3"
      header-class="justify-content-end"
      @hidden="onClose()"
    >
      <template #modal-header="{ close }">
        <div class="d-flex">
          <div class="col-11"></div>
          <div v-if="content.titreFenetreModale" class="posBtnClose">
            <button class="compteClair btnClose" @click="close()">
              <svg-icon
                icon-name="icone-fermer-mince"
                color="$couleur-primaire"
                className="iconeFermer"
              ></svg-icon>
            </button>
          </div>
        </div>
        <div class="d-flex mt-4">
          <div v-if="content.titreFenetreModale" class="col-12 px-0">
            <h2
              class="compteClair grandTitre ml-3 ml-md-5 mr-1"
              v-html="jel_replaceTokens(content.titreFenetreModale)"
            ></h2>
          </div>
        </div>
      </template>

      <div>
        <div class="texte text-left graphik_regular mx-1 pb-0 mb-3 mb-md-3" v-html="textePromo" />
        <MessageMel
          v-show="message"
          :content="messageErreur"
          class="mx-n1 mx-md-1 pt-0 mb-1 mb-md-2"
        ></MessageMel>

        <!-- tag="div" nécessaire pour accessibilité, éviter div dans un span -->
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }" tag="div" class="mx-n1">
          <b-form @submit.stop.prevent="handleSubmit(onSubmit)">
            <ValidationProvider
              v-slot="{ errors }"
              :name="content.libCodePromo"
              :rules="`required|is_code_promo_valid`"
              tag="div"
            >
              <div class="col-12 col-lg-11 col-md-11 col-xl-9">
                <b-form-group :label="content.libCodePromo" label-for="champCodePromo">
                  <b-form-input
                    id="champCodePromo"
                    v-model="codePromo"
                    class="text-uppercase pr-1"
                    autocomplete="off"
                    maxlength="16"
                    :class="{ 'is-invalid': errors.length > 0 }"
                    @blur.native="forceValidate()"
                  />
                </b-form-group>
                <ErreurValidation
                  v-if="errors[0] !== 'MSG00-04'"
                  id="promo-invalid-feedback"
                  class="mt-n2 pb-0"
                  :message="errors[0]"
                ></ErreurValidation>
              </div>
              <div class="col-1"></div>
              <div
                class="d-flex flex-column"
                :class="[
                  content.classeBoutonContinuer
                    ? content.classeBoutonContinuer
                    : 'align-items-center mt-2 mb-2',
                ]"
              >
                <b-button
                  type="submit"
                  variant="primaire"
                  class="btn w-auto hauteur px-4"
                  :disabled="errors.length > 0 || codePromo.length === 0"
                  :class="{ valid: errors.length == 0 }"
                >
                  <div v-if="isSubmitted" class="mr-1">
                    <b-spinner small :label="$t('chargement')"></b-spinner>
                  </div>
                  {{ content.libBoutonContinuer }}</b-button
                >
                <b-link class="lienSecondaire pb-0" @click="$bvModal.hide(modaleUUID)">
                  {{ content.libBoutonAnnuler }}
                </b-link>
              </div>
            </ValidationProvider>
          </b-form>
        </ValidationObserver>
      </div>
    </b-modal>
  </div>
</template>

<script>
/* Ce composant est utilisé afin de recupérer ou de faire la saisie ainsi que la validation d'un code promo */
// TODO: Utiliser jel_replaceTokens TokenReplaceHelper = remplacé pour faire le travail --> Ajouter une méthode à TokenReplaceHelper pour remplacer un token dans un string donnée

import MessageMel from '@/components/base/MessageMel';
import ErreurValidation from '@/components/formulaire/compte/ErreurValidation';

import MessageHelpers from '@/helpers/MessageHelpers';
import { PageMapping } from '@/helpers/PageMappingHelpers';
import { isProductSource2eChance } from '@/helpers/ProductSourceHelpers';
import { formatNombreEnMonetaire } from '@/helpers/StringHelpers';

import { mixinEnvironnement } from '@/mixins/mixinEnvironnement';
import promo from '@/services/api/compte/promo';

export default {
  name: 'Promo',
  components: { ErreurValidation, MessageMel },
  mixins: [mixinEnvironnement],
  props: { content: { type: Object, required: true } },
  data() {
    return {
      codePromo: '',
      textePromo: this.content.texteFenetreModale,
      isPromoVisible: this.content.indActif === 'true' && !isProductSource2eChance(),
      isSubmitted: false,
      message: null,
      messageErreur: {
        idHTML: 'messageErreurPromo',
        idHTMLContenu: 'zoneMessageErreurPromo',
      },
    };
  },
  computed: {
    CS_INSCRIPTION: () => 'inscription',
    modaleUUID() {
      return this.uid;
    },
    promoInfo: {
      get() {
        return this.$store.state.promo;
      },
    },
    texteFenetreModale() {
      return this.textePromo.replace(
        '{{valeur}}',
        formatNombreEnMonetaire(this.promoInfo.montant, 2)
      );
    },
  },
  methods: {
    afficherMessageErreur(msg) {
      const span = document.getElementById('zoneMessageErreurPromo');
      span.textContent = msg;
    },
    forceValidate() {
      this.$refs.observer.validate();
    },

    onClose() {
      this.codePromo = '';
    },
    onSubmit() {
      if (this.isSubmitted) {
        return;
      }

      /*
       * On reset les messages d'Erreur Serveur lors du submit du formulaire
       * Si il y a une erreur affichée
       * Spécifications: https://lotoquebec.atlassian.net/browse/PECOMM-197
       */
      if (this.message) {
        this.afficherMessageErreur(null);
      }

      this.isSubmitted = true;
      promo
        .recherchePromo(this.codePromo.toUpperCase())
        .then(() => {
          this.$bvModal.hide(this.modaleUUID);
          if (this.$router.currentRoute.path !== PageMapping.OFFRE.siteUrl) {
            const uriReturn = this.$store.getters['routes/getUrlFromWebsitePath'](
              PageMapping.OFFRE.siteUrl
            );
            this.$router.push(uriReturn).catch(() => {});
          }
        })
        .catch((error) => {
          if (error === 'EXPIRED') {
            // TODO: Gestion du message d'erreur en fonction du retour du service Promo
            this.message = this.$i18n.t('compte.codePromo.erreurExpire');
            this.afficherMessageErreur(this.message);
          } else {
            MessageHelpers.obtenirMessage('MSG01', this.$root)
              .then((msgResp) => {
                const msg = {
                  title: msgResp.msgTitre,
                  details: this.modifierMessage(msgResp.msgDetail),
                };
                this.message = msg;
                this.afficherMessageErreur(msg);
                return msgResp;
              })
              .catch((error) => {
                this.message = this.$i18n.t('compte.codePromo.erreurSysteme');
                this.afficherMessageErreur(this.message);
                console.error('Erreur de récupération du message!', error);
              });
          }
        });
      this.isSubmitted = false;
    },
  },
};
</script>
<!-- TODO: Mettre dans le scss global si la bordure de l'entête n'est jamais requise -->
<style lang="scss">
.modal-header {
  border: none !important;
}

.posBtnClose {
  margin-top: 0px;
}
.btnClose {
  @media (max-width: 575px) {
    margin-left: 0px;
  }
  @media (min-width: 1025px) {
    margin-left: 14px;
  }
  border: none;
  background-color: $couleur-blanc;
  position: absolute;
}
</style>
